module.exports = __webpack_public_path__ + "img/ux.b04624eb.svg";